export enum EventExportMethod {
    None = "None",
    GoogleCalendar = "GoogleCalendar",
    IcalFile = "IcalFile"
}
